import { createAsyncThunk } from '@reduxjs/toolkit';
import { ResponseError } from 'shared/common/errors/responseError';
import { fetchCallbackForm } from 'shared/common/services/fetchCallbackForm';
import { TFetchFormParams } from 'shared/common/types/form';
import { IThunkApi } from 'shared/common/types/redux';

export const sendForm = createAsyncThunk<string, TFetchFormParams, IThunkApi>(
  'form/sendForm',
  async (params, _thunkApi) => {
    const { rejectWithValue, extra } = _thunkApi;

    try {
      const { statusCode, response } = await fetchCallbackForm(extra, params);

      if (statusCode === 200) {
        return response.status;
      }

      throw new ResponseError({
        domain: 'sendForm',
        message: response.message,
      });
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
